export default "__VITE_ASSET__C7Y0aDdF__"